import React, { useContext, useEffect, Fragment } from 'react';
import AuthContext from '../../Context/autenticacion/authContext';
import RulesAdmin from './RulesAdmin';
import AlertNotAuthorized from '../../Complements/AlertNotAuthorized';
import BusinessRulesSubAdmin from './BusinessRulesSubAdmin';

export default function ClientIndex() {
   //Extraer la informacion de autenticación
   const authContext = useContext(AuthContext);
   const { usuario, usuarioAutenticado } = authContext;

   useEffect(() => {
    usuarioAutenticado();
  }, []);

  let component;
  if(usuario){
    switch (usuario.type) {
		  case '1':
			component = <RulesAdmin />
			break;
      	  case '3': 
			component = <BusinessRulesSubAdmin />
			break;
		  default:
			component = <AlertNotAuthorized mensaje={"No tienes los suficientes permisos para ver esta página"}/>
			break;
    }
  }
  return (
    <Fragment>
      {component}
    </Fragment>
  )
}
